import { useMutation } from "@apollo/client";
import { saveAs } from "file-saver";

import { STAND_COMMENTS_EXPORT_EXCEL } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";

const useMutationStandCommentsExportExcel = () => {
    const [ _setStandCommentsExportExcel, { loading } ] = useMutation(
        STAND_COMMENTS_EXPORT_EXCEL,
        {
            update(cache, { data }) {
                const payload = data?.commentsExportExcel;
                const file = payload?.file;

                successNotification({
                    title: payload?.label,
                    description: payload?.message,
                });

                if (!file) {
                    return;
                }

                const parts = file.split("/");
                const fileName = parts[ parts.length - 1 ];
                saveAs(file, fileName);
            },
            onError(error) {
                errorNotification(error);
            },
        },
    );

    return {
        _setStandCommentsExportExcel,
        loadingMutationStandCommentsExportExcel: loading,
    };
};

export default useMutationStandCommentsExportExcel;
